import { useAtomValue } from "jotai";
import { navbarHeightAtom, tradingViewAiOverlaysAtom } from "@/store/atoms";
import TradingViewWidget from "@/components/dashboard/trading-tools/TradingViewWidget";
import TradingViewAiOverlaysToggle from "@/components/dashboard/trading-tools/TradingViewAiOverlaysToggle";
import { cn } from "@/utils/utils";

export default function TradingViewToolView() {
  const navbarHeight = useAtomValue(navbarHeightAtom);
  const aiOverlaysEnabled = useAtomValue(tradingViewAiOverlaysAtom);
  const chartHeight = Math.max(navbarHeight ? navbarHeight + 48 : 120, 120);

  return (
    <div
      style={{ height: `calc(100vh - ${chartHeight}px)` }}
      className="flex w-full flex-col bg-[#050505] px-4 py-4 sm:px-5"
    >
      <div className="mb-4 flex shrink-0 items-center justify-end lg:hidden">
        <TradingViewAiOverlaysToggle />
      </div>

      <div
        className="relative min-h-[520px] flex-1 overflow-hidden rounded-xl border border-white/10 bg-[#0F0F0F]"
        style={{ height: "100%" }}
      >
        {aiOverlaysEnabled && (
          <div
            className={cn(
              "pointer-events-none absolute inset-0 z-[1]",
              "bg-[radial-gradient(circle_at_20%_30%,rgba(28,205,230,0.06),transparent_45%),radial-gradient(circle_at_80%_70%,rgba(219,214,51,0.05),transparent_40%)]",
            )}
            aria-hidden
          />
        )}
        <div className="relative z-0 h-full w-full">
          <TradingViewWidget />
        </div>
      </div>
    </div>
  );
}
